import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { DNABox, Icon } from '@alucio/lux-ui';
import InputComponent from 'src/components/Publishers/InputComponent';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  titleSearchInputWrapper: {
    width: 260,
    maxWidth: '100%',
  },
  titleSearchInput: {
    backgroundColor: colors['color-white'],
    borderColor: colors['color-border-light-primary'],
    borderRadius: 100,
    minHeight: 32,
  },
  titleSearchTextInput: {
    borderRadius: 0,
  },
  titleSearchIcon: {
    color: colors['color-text-light-subtle'],
    height: 16,
    width: 16,
  },
  hiddenClearIcon: {
    opacity: 0,
  },
});

const ICONS = {
  CLOSE: 'x',
  MAGNIFY: 'magnifying-glass',
}

const DocumentTitleSearchInput: React.FC<{
  value: string;
  onChangeText: (text: string) => void;
}> = ({ value, onChangeText }) => {
  const renderSearchIcon = () => (
    <Icon style={styles.titleSearchIcon} name={ICONS.MAGNIFY} />
  );

  const renderClearIcon = () => {
    return (
      <TouchableOpacity
        disabled={!value}
        onPress={() => onChangeText('')}
        style={!value && styles.hiddenClearIcon}
      >
        <Icon style={styles.titleSearchIcon} name={ICONS.CLOSE} />
      </TouchableOpacity>
    );
  }

  return (
    <DNABox style={styles.titleSearchInputWrapper}>
      <InputComponent
        value={value}
        hideLabel
        onChangeText={onChangeText}
        title="Search by file name"
        removeMarginPadding
        inputStyle={styles.titleSearchInput}
        textStyle={styles.titleSearchTextInput}
        getLeftIconFunction={renderSearchIcon}
        getRightIconFunction={renderClearIcon}
        size="sm"
        autoCorrect={false}
        autoCapitalize="none"
        testID="library-title-search-input"
      />
    </DNABox>
  );
}

export default DocumentTitleSearchInput;
